import { formatDateForDisplay } from '../../../../utils/utils';
import * as RenewalStatus from '../../../../constants/RenewalStatus';
import RenewalPageWrapper from '../../../containers/renewals/RenewalPageWrapper/RenewalPageWrapper';
import React from 'react';

const columns = (props) => [
  {
    header: {
      display: props.intl.formatMessage({ id: 'customer_number' }),
      sortBy: 'deliverToCustomerNumber'
    },
    accessor: (customer) => ({
      display: customer.deliverToCustomerNumber
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'customer_name' }),
      sortBy: 'deliverToCustomerName'
    },
    accessor: (customer) => ({
      display: customer.deliverToCustomerName.toLowerCase(),
      style: {
        textTransform: 'capitalize'
      }
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'proposed_date' })
    },
    accessor: (customer) => ({
      display:
        !!customer.workflowTicket &&
        customer.workflowTicket.status ===
        RenewalStatus.CUSTOMER_APPROVAL_REQUIRED.name
          ? formatDateForDisplay(customer.workflowTicket.ameriPrideApproveDate)
          : null
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'exp_date' }),
      sortBy: 'contract.contractDateInactive'
    },
    accessor: (customer) => ({
      display: formatDateForDisplay(customer.contract.contractDateInactive)
    }),
    shared: {
      isNumeric: true
    }
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'base_price_increase' }),
      sortBy: 'renewalPriceIncrease'
    },
    accessor: (customer) => ({
      display: `${customer.renewalPriceIncrease * 100}%`
    }),
    shared: {
      isNumeric: true
    }
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'route' }),
      sortBy: 'routeNumber'
    },
    accessor: (customer) => ({
      display: customer.routeNumber
    }),
    shared: {
      isNumeric: true
    }
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'product_added_or_removed' }).split("\n").map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ))
    },
    accessor: (customer) => {
      const hasAdded = customer.contract?.hasRecentlyAddedProducts;
      const hasRemoved = customer.contract?.hasRecentlyRemovedProducts;

      let symbol = '';
      let className = '';
      let secondarySymbol = '';
      let secondaryClassName = '';

      if(hasAdded && hasRemoved){
        symbol = '+';
        className = 'trigger-icon plus';
        secondarySymbol = '-';
        secondaryClassName = 'trigger-icon minus';
        return {
          display: (
            <>
              {hasAdded && <div className={className}> {symbol} </div>}
              {hasRemoved && <div className={secondaryClassName}> {secondarySymbol} </div>}
            </>
          )
        };
      }
      else if (hasAdded) {
        symbol = '+';
        className = 'trigger-icon plus';
        return {
          display: (
            <div className={className}>
              {symbol}
            </div>
          )
        };
      } else if (hasRemoved) {
        symbol = '–';
        className = 'trigger-icon minus';
        return {
          display: (
            <div className={className}>
              {symbol}
            </div>
          )
        };
      }
    }
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'renewal_status' })
    },
    accessor: (customer) => ({
      display: RenewalStatus[customer.renewalStatus].display
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'current_approval_tier' })
    },
    accessor: (customer) => ({
      display:
        !!customer.workflowTicket &&
        customer.workflowTicket.currentApprovalTier !== 'None'
          ? customer.workflowTicket.currentApprovalTier
          : ''
    })
  }
];

export default columns;